import styled from "styled-components";

export const Layout = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 10vh;
`;
